import { req } from 'vuelidate/lib/validators/common'
import { withParams } from 'vuelidate'
import { CPF } from 'cpf_cnpj'

export default withParams({ type: 'isCPF' }, value => !req(value) || CPF.isValid(value))
